import { createSlice } from "@reduxjs/toolkit";

export const syncProperties = ["sessionMaxPermille", "DrunkDrinks"];

const syncSlice = createSlice({
  name: "sync",
  initialState: {
    syncing: [],
  } as {
    syncing: string[];
  } & { [property: string]: Date | number },
  reducers: {
    setSyncDate: (state, action) => {
      const { property, date, revision } = action.payload;
      state[property] = date;
      state[property + "Revision"] = revision;
    },
    removeSyncDate: (state, action) => {
      const { property } = action.payload;
      delete state[property];
      delete state[property + "Revision"];
    },
    setSyncing: (state, action) => {
      const { property } = action.payload;
      state.syncing.push(property);
    },
    setNotSyncing: (state, action) => {
      const { property } = action.payload;
      state.syncing = state.syncing.filter((p) => p !== property);
    },
  },
});

export const { setSyncDate, removeSyncDate, setSyncing, setNotSyncing } =
  syncSlice.actions;

export default syncSlice.reducer;
